/*
 * @Author       : aa
 * @Date         : 2020-06-15 12:05:17
 * @Description  : file content
 * @FilePath     : \vue-gaokao-ebook\src\main.js
 */
import 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import '@/assets/js/dialog-drag.js'

import router from './router'
import VueRouter from 'vue-router'
import axios from 'axios';
import katex from 'katex';

import '@/assets/js/prototype.js';

import common from '@/assets/js/common.js';
Vue.prototype.common = common;

import VueCookies from 'vue-cookies'
import VueClipboard from 'vue-clipboard2'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)
import SIdentify from './views/login/identify' //注意引入路径
Vue.use(SIdentify)
// import AudioRecorder from 'vue-audio-recorder'
// Vue.use(AudioRecorder)

import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);

import store from '@/store/store.js'

import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

import APIS from "@/assets/api/apis.js"
Vue.prototype.$APIS = APIS
import dataHandle from '@/assets/js/data-handle.js'
Vue.prototype.$HTTP = dataHandle

import MathLive from "../node_modules/mathlive/dist/mathlive.mjs";
 //   import Mathfield from "./node_modules/mathlive/dist/vue-mathlive.mjs";
import Mathfield from "../node_modules/mathlive/dist/vue-mathlive.mjs";
Vue.use(Mathfield, MathLive);

//全局组件注册
import Header from '@/components/header/header'
import Footer from '@/components/footer/footer'

//字体
import '@/assets/css/font/DIGIFAW.css'

//全局css
import '@/assets/css/global.css'
//自适应
import '@/utils/flexible'

import 'katex/dist/katex.css'
import './utils/global.js'
import 'default-passive-events' // 解决控制台警告
import config from '@/config/config.js'

Vue.prototype.$config = config;
Vue.component('Header',Header);
Vue.component('Footer',Footer);

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import userUtil from '@/assets/js/userUtil'; 
Vue.prototype.$userUtil = userUtil

import SUBJECT_COLLECTION from '@/assets/js/subject-data.js'
Vue.prototype.$subjectMap = SUBJECT_COLLECTION


window.katex=katex;

// import VueAudio from 'vue-audio-better'
// import vueAudioRecorderMin from 'vue-audio-recorder';
// Vue.use(VueAudio)

Vue.use(VueQuillEditor)
Vue.config.productionTip = false
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueCookies)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(ElementUI);
Vue.use(VueRouter)

axios.defaults.withCredentials = true;
axios.defaults.baseURL = '/apis'
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;



// import KaTeX from 'vue-katex';
// import 'katex/dist/katex.min.css';

// Vue.use(KaTeX);

// Vue.use(Katex, {
//   globalOptions: {
//     //... Define globally applied KaTeX options here
//   }
// });


new Vue({
  router,
  store,
  render: h => h(App),
  data: {
    eventHub: new Vue(),
    UserIndicateId: '',
    document_title: "智能统练-北京尚壹本科技"
  }
}).$mount('#app');

